import React, { Component } from 'react';

export default class FreeDownloads extends Component {
	renderDownloadsList( downloads ) {
		let sliced = downloads.slice( 0, 3 );
		return (
			<ul className="assets-list">
				{ sliced.map( download => {
					if ( download.file.length ) {
						return (
							<li key={ download.file } id={ `asset_${download.file}` } className="asset">
								<input type="hidden" className="asset_id" name="asset_id[]" value={ download.file } />
								<a href={ download.link } target="_blank">
									<span className="glyphicon glyphicon-download" aria-hidden="true"></span>
									{ download.title } ({ download.ext }) </a>
							</li>
						);
					}
				} ) }
				{ this.renderSeeAll( sliced.length, downloads.length, this.props.bookLink ) }
			</ul>
		);
	}

	renderSeeAll( slicedLength, downloadsLength, link ) {
		if ( slicedLength < downloadsLength ) {
			return (
				<li><a className="see-all" href={ link }>View all downloads
					<span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></a>
				</li>
			);
		}
	}

	render() {
		if ( 'undefined' !== typeof this.props.downloads && this.props.downloads.length ) {
			return (
				<div>
					<h4 className="book-downloads-title assets-list-title">Free downloads ({ this.props.downloads.length })</h4>
					{ this.renderDownloadsList( this.props.downloads ) }
				</div>
			);
		} else {
			return (
				<span />
			);
		}
	}
}